import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { User, get as getUser } from "../lib/userLib";
import UserCard from "./userCard";
import InboxCard from "./inboxCard";

const UserDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      if (!id) {
        // Handle the case where id is undefined
        console.error("User ID is undefined");
        setLoading(false);
        return;
      }
      try {
        const userData = await getUser(id);
        setUser(userData);
      } catch (error) {
        console.error("Error fetching user:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  if (loading) {
    return <div className="text-gray-800 dark:text-white">Loading...</div>; // Render a loading indicator
  }

  if (!user) {
    return <div>User {id} not found</div>;
  }

  const inboxId = user.inboxes?.[0]?.id;

  return (
    <div className="container mx-auto p-4">
      <UserCard key={user.id} user={user} />
      {inboxId && <InboxCard inboxId={inboxId} />}
    </div>
  );
};

export default UserDetail;
